<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Iframe from './Iframe/index.vue';
import { getExternalDomain } from '../../../../../shared/helpers/env';

interface Props {
  id?: number;
  name?: string;
  accountId?: number;
  country?: string;
  site?: string;
}

const { id, name, accountId, country, site } = defineProps<Props>();
const { t } = useI18n();

const pageTitle = computed(() => `${t('AGENT_MGMT.EDIT.TITLE')} - ${name}`);

const emit = defineEmits(['close', 'refresh']);

const onClose = (refresh?: boolean) => {
  emit('close');
  if (refresh) {
    emit('refresh');
  }
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto agent-edit-container">
    <woot-modal-header :header-title="pageTitle" />
    <Iframe
      :src="`${getExternalDomain()}/external/agent?type=edit&id=${id}&accountId=${accountId}&country=${country}&site=${site}`"
      @close="onClose"
    />
  </div>
</template>
<style scoped lang="scss">
.agent-edit-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .iframe-container {
    flex: 1;
  }
}
</style>
